export default "__VITE_ASSET__CgzqDwh2__"